"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const api_1 = require("@/api");
const functions_1 = require("@/common/functions");
const errors_1 = require("@/common/errors");
const _1 = require(".");
function default_1({ data, isFormData, confirm, setPaymentDetail, onSuccess, onError, onFinally, }) {
    return __awaiter(this, void 0, void 0, function* () {
        const orderId = (0, functions_1.getNumberFromUrl)(window.location.pathname);
        const updateData = isFormData ? api_1.patchFormData : api_1.patchData;
        yield updateData(`/api/v1/order/${orderId}/payment`, data)
            .then(onSuccess)
            .catch((err) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d;
            const errorStatus = (_a = err.response) === null || _a === void 0 ? void 0 : _a.status;
            const errorCode = (_d = (_c = (_b = err.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.meta) === null || _d === void 0 ? void 0 : _d.alert_type;
            if (errorStatus === 404)
                (0, errors_1.notFoundConfirm)({ confirm, isForm: true });
            else if (errorStatus === 403)
                (0, errors_1.handle403Error)(err);
            else if (errorStatus === 400) {
                yield (0, _1.handlePatchPaymentDetail400Error)({ errorCode, setPaymentDetail, confirm });
            }
            else {
                (0, errors_1.commonErrorConfirm)({ confirm, errorCode: errorCode || errorStatus });
            }
            onError && onError(errorCode);
        }))
            .finally(onFinally);
    });
}
exports.default = default_1;
